export const InputVariants = Object.freeze({
    FrozenGlass: 'frozenGlass',
    Neumorphic: 'neumorphic',
    Markup: 'markup',
    Compact: 'compact'
});
